import { createRef, useEffect, useState, useCallback, useMemo } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';
import { SelectedGroupServicesProps, SubCategoriesProps } from '../../interfaces/interfaces';
import { NoElements } from './noElements';
import { ServiceClient } from '../../helpers/client';
import { ServiceGroup } from 'orderme-api-integration-client';
import { useNavigate } from 'react-router';
import { ServiceLogoItem } from '../serviceLogoItem/serviceLogoItem';
import { getUserId } from '../../helpers/customerHelper';
import { useRouteNavigator } from '../../routes/useRouteNavigator';

export function SubCategories(props: SubCategoriesProps) {
  const navigate = useNavigate();
  const routeNavigator = useRouteNavigator();
  const { category, tabIndex } = props;
  const servicesClient = useMemo(() => new ServiceClient(), []);
  const [tabContent, setTabContent] = useState<ServiceGroup[]>();
  const listRef = createRef<any>();
  const theme = useTheme();
  const hasMultipleColumns = useMediaQuery(theme.breakpoints.up('sm'));

  useEffect(() => {
    if (listRef?.current?.scrollTop !== 0) {
      listRef?.current?.scrollTo(0, 0);
    }
  }, [tabIndex, listRef]);

  const setCurrentTab = useCallback(
    (id: string) => {
      servicesClient
        .getCategoryGroups(id, getUserId())
        .then((response) => {
          setTabContent(response);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    [servicesClient]
  );

  useEffect(() => {
    setCurrentTab(category.id);
  }, [category, setCurrentTab]);

  const openServicePage = (service: ServiceGroup) => {
    navigate(routeNavigator.getServicesPath(), {
      state: {
        serviceCategory: category,
        serviceGroup: service,
      } as SelectedGroupServicesProps,
    });
  };

  const body = () => {
    return (
      <Box ref={listRef} sx={{ backgroundColor: 'primary.main', overflow: 'auto' }} className="categories-list">
        <Grid container spacing={hasMultipleColumns ? 1 : 0} sx={{ pb: hasMultipleColumns ? '25px' : '15px' }}>
          {tabContent.map((service, index) => (
            <Grid className="categories-list-item" key={index} size={{ xs: 12, sm: 6, lg: 4, xl: 3 }}>
              <ServiceLogoItem service={service} isButton={true} open={() => openServicePage(service)} />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  };

  return (
    <Box>
      {tabContent !== undefined && tabContent.length === 0 && <NoElements />}
      {tabContent !== undefined && tabContent.length > 0 && body()}
    </Box>
  );
}
